module.exports = __webpack_public_path__ + "static/media/cc-bobina1.08293377.jpg";